import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

const LANGS = [
  { code: "en", label: "EN" },
  { code: "hi", label: "HI" },
  { code: "mr", label: "MR" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const active = i18n.language?.slice(0, 2) || "en";
  return (
    <div className="flex items-center rounded-full border border-slate-200 bg-white p-0.5" data-testid="lang-switcher">
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-switcher-${l.code}`}
          onClick={() => i18n.changeLanguage(l.code)}
          className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${
            active === l.code
              ? "bg-[#0F2942] text-white"
              : "text-slate-600 hover:bg-slate-100 hover:text-[#0F2942]"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
